module.exports = __webpack_public_path__ + "assets/StarCheckIconBlue.06d60f194699881de677e86c2b84e6e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/stars/StarCheckIconBlue.svg
// module id = 871
// module chunks = 0